import React, { useEffect, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import InputTag from '../../../modules/admin-dashboard/InputTag/InputTag'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import './trainer-Dashboard.css'
import { useStore } from '../../../contexts/StoreProvider';
import { observer } from 'mobx-react';
import RoutesConstants from '../../../shared-components/Routes/routes.constants';
import { ITrainerGroup, ITrainerGroupFilter } from '../../../models/response/ITrainerGroupResponse'
import SendInvitiesEmailPopupHOC from '../hoc/SendInvitiesEmailPopupHOC'
import SendEmail from '../SendEmail/SendEmail'
import OpenTrainerPopupHOC from '../hoc/OpenTrainerPopupHOC'
import { ITrainerInfo } from '../../../models/response/ITrainerResponse'
import { useNavigate } from 'react-router-dom'
import { formatMessage } from '../../../translations/format-message'
import DeletePopup from '../../agent-dashboard/components/Delete/DeletePopup'
import DeletePopupHOC from '../../agent-dashboard/hoc/DeletePopupHOC'
import RepeatForwardMailInfoPopupHOC from '../hoc/RepeatForwardMailInfoPopupHOC'
import RepeatForwardMailInfo from './RepeatForwardMailInfo'
import EditTrainerInvitedInfo from './EditTrainerInvitedInfo'
import TestCompare from '../../test-compare/TestCompare'
import { ITestInfo } from '../../../models/ITestInfo'
import { pageLimitOptions } from '../../../constants/options.constant'
import Pagination from '../../../shared-components/Grid/Pagination'

const TrainerDashboard = (props: any) => {
    const { trainerStore } = useStore();
    const { getAllGroups, resetAllTrainerGroups, resetDeleteInvitesState, deleteTrainerInvitiesState, allTrainerGroups, 
        sentTrainerInviteState, searchingTrainerInvitiesText, searchingTrainerInvitiesState, 
        getAllTrainerInvities, allTrainerlist, allTrainerInvitiesCount, getTrainerInvitiesInfo, 
        deleteTrainerInvities, updatePageSize, updatePageNumber, trainerPaginationState, resetPagingState} = trainerStore;
    const [TrainerGroups, setTrainerGroups] = useState<Array<ITrainerGroupFilter>>([{id : 0, value: 'All Groups'}])
    const [openTrainerId, setOpenTrainerId] = useState<Number>(0)
    const [deleteInvitesId, setDeleteInvitesId] = useState<number>(-1);
    const [deleteInvitesName, setDeleteInvitesName] = useState<string>("");
    const navigate = useNavigate();
    const GetAllTrainerList = () => {
        getAllTrainerInvities(trainerPaginationState.PagingDetails.PageNo,trainerPaginationState.PagingDetails.PageSize,searchingTrainerInvitiesState.searchText, searchingTrainerInvitiesState.filter);
        getTrainerInvitiesInfo();
    };

    const [selectedTestsForComparison, setSelectedTestsForComparison] = useState<number[]>([])

    const GetAllTrainerListBySearch = () => {
        getAllTrainerInvities(trainerPaginationState.PagingDetails.PageNo,trainerPaginationState.PagingDetails.PageSize,searchingTrainerInvitiesState.searchText, searchingTrainerInvitiesState.filter);
    };

    useEffect(() => {
        if (allTrainerGroups.length > 0) {
            const changingKey: ITrainerGroupFilter[] = [{id : 0, value: 'All Groups'}]
            changingKey.push(...allTrainerGroups.map((key: ITrainerGroup) => {
                return { id: key.GroupId, value: key.GroupName }
            }))
            setTrainerGroups(changingKey)
        }
    }, [allTrainerGroups])

    useEffect(() => {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        resetAllTrainerGroups();
        getAllGroups();
    }, []);

    useEffect(() => {
        if (deleteTrainerInvitiesState.success) {
            resetDeleteInvitesState();
            getAllTrainerInvities(trainerPaginationState.PagingDetails.PageNo,trainerPaginationState.PagingDetails.PageSize)
            getTrainerInvitiesInfo()
            props.deletePopupToggleHandler();
        }
    }, [deleteTrainerInvitiesState.success]);


  // get all trainer based on pagerChange
    useEffect(() => {
       if(trainerPaginationState.PagingDetails.isPagerChange){
            handleRemoveAllTests();
            GetAllTrainerList();
            resetPagingState();
       }
    }, [trainerPaginationState.PagingDetails.isPagerChange]);


    const [disablePagination, setDisablePagination] = useState<boolean>(false);

    const onPageChanged = (pageNumber: number) => {
      updatePageNumber(pageNumber);
    };

 
    const onPageLimitChanged = (evt: any) => {
      updatePageSize(parseInt(evt.target.value));
      let pages: number;
      pages = props.data && Math.ceil(props.data.length / evt.target.value);
    
    };
    const performSearch = () => {
        GetAllTrainerListBySearch();
    };

    const handleKeyDown = (event: any) => {
        if (event.key === 'Enter') {
            GetAllTrainerListBySearch();
        }
    }

    const handleFilteredGroupName = (e: string) => {
        searchingTrainerInvitiesState.filter = parseInt(e);
        GetAllTrainerListBySearch();
    };

    const handleCreateSentInvitiesModalClose = () => {
        props.sendInvitiesEmailPopupToggleHandler();
    }

    const handleCreateSentInvitiesModalOpen = () => {
        props.sendInvitiesEmailPopupToggleHandler();
    }

    const handleOpenTrainerModalClose = () => {
        props.openTrainerToggleHandler();
    }

    const handleOpenTrainerModalOpen = (id: number) => {
        props.openTrainerToggleHandler();
        setOpenTrainerId(id)
    }
 
    const handleRemoveFromCompariosn = (testIdToBeRemoved: number) => {
        const remainingTests = selectedTestsForComparison.filter((testId: any) => testId != testIdToBeRemoved)
        if (remainingTests) {
            setSelectedTestsForComparison(remainingTests);
        }
    }

    const handleRemoveAllTests = () => {
        // sethideAndShowButton([])
        setSelectedTestsForComparison([]);
    }


    const handleAddToComparison = (id: number) => {
        setSelectedTestsForComparison([...selectedTestsForComparison, id])
    }

    const handleSelectAll = () => {
        const usersList = allTrainerlist.filter((old: any) => old.TestId !== 0)
        const usersTestIdList = usersList.flatMap((trainer: ITrainerInfo) => (trainer.TestId));
        setSelectedTestsForComparison([...usersTestIdList])
    }

    const handleRenewAccount = () => {
        navigate(RoutesConstants.TrainerAccountPayment)
    }

    const handleDeleteClick = (eventId: number, invitesName: string, event: any) => {
        const isButtonDisabled = event.currentTarget.disabled;
        if (!isButtonDisabled) {
            setDeleteInvitesId(eventId);
            setDeleteInvitesName(invitesName);
            props.deletePopupToggleHandler();
        }
    };

    const deleteInvitesHandler = (invitesId: number) => {
        deleteTrainerInvities(invitesId)
    }
    const handleOpenEmailModalClose = () => {
        props.sendMailToggleHandler();
    }
    const handleOpenEmailModalOpen = (id: number) => {
        props.sendMailToggleHandler();
        setOpenTrainerId(id)
    }
    
    return (
        <>
            {props.showSendInvitiesEmailPopup && (
                <SendEmail modalClosed={handleCreateSentInvitiesModalClose} isLoading={sentTrainerInviteState.inProgress} />
            )}

            {props.showOpenTrainerPopup && (
                <EditTrainerInvitedInfo modalClosed={handleOpenTrainerModalClose} openTrainerId={openTrainerId} />
            )}
            {props.showDeletePopup && (
                <DeletePopup modalClosed={props.deletePopupToggleHandler} isLoading={deleteTrainerInvitiesState.inProgress} Id={deleteInvitesId} Title={deleteInvitesName} deleteHandler={deleteInvitesHandler} />
            )}
            {props.showSendMailPopup && (
                <RepeatForwardMailInfo modalClosed={handleOpenEmailModalClose} openTrainerId={openTrainerId}/>
            )}

            <div className="dashboar-container  ">
                <div className="dashboard_heading">
                    <div className="container">
                        <h1>
                            <FormattedMessage id="Trainer_Dashboard" />
                        </h1>
                    </div>
                </div>
                <div className={`dashboardNavPane  p-2 ${!allTrainerInvitiesCount.IsValidSubscriptionDate ? 'alert alert-danger m-0' : ""}`}>
                    <div className='container'>
                        <div className='d-flex justify-content-between align-items-center'>
                            <p>
                                {!allTrainerInvitiesCount.IsValidSubscriptionDate ? (
                                    <> <span className='text-danger'><i className="fas fa-exclamation-triangle"></i> <FormattedMessage id="SendEmail_Error_SubscriptionExpiry" /></span></>
                                    ) : (
                                    <><FormattedMessage id="Trainer_Next_renewal" /> : {allTrainerInvitiesCount.SubscriptionExpiryDate}</>
                                )}
                            </p>
                            <button className={`btn ${!allTrainerInvitiesCount.IsValidSubscriptionDate ? 'btn-danger' : 'btn-warning'}`} onClick={handleRenewAccount}><FormattedMessage id="Trainer_Renew_Now" /></button>
                        </div>
                    </div>
                </div>
                <div className="dashboardTopbar">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-xl-8 col-12 d-flex flex-wrap justify-content-between align-items-center">
                                <InputTag size="search" icon={true} inputValue={searchingTrainerInvitiesText} onKeyDown={handleKeyDown} inputvalue={searchingTrainerInvitiesState.searchText} inputType="text" clickedFn={() => performSearch()} placeholderText={formatMessage("search")} FaIcon={faSearch} />
                                <div className='justify-content-between align-items-center d-flex mt-2 mt-md-0'>
                                    <p className="text-dark"><FormattedMessage id="Trainer_Invities_Count" />: {allTrainerInvitiesCount.TrainerInvites} </p>
                                    <button className="btn btn-secondary ms-2" onClick={handleCreateSentInvitiesModalOpen} disabled={!allTrainerInvitiesCount.IsValidSubscriptionDate}>
                                        <i className='fa fa-envelope'></i> <FormattedMessage id="Trainer_Send_Invites_button" />
                                    </button>
                                    <button className="btn btn-info ms-2" onClick={() => navigate(RoutesConstants.TrainerRecharge)}>
                                        <i className='fas fa-money-bill'></i> <FormattedMessage id="recharge" />
                                    </button>
                                </div>
                            </div>
                            <div className="col-xl-4  col-12 text-md-end text-center mt-2 mt-xl-0">
                                <div className='input-group'>
                                    <select className="form-select form-control" onChange={(e) => handleFilteredGroupName(e.target.value)}>
                                        {TrainerGroups?.map((group: ITrainerGroupFilter) => {
                                            return (
                                                <option value={group.id} >{group.value}</option>
                                            )
                                        })
                                        }
                                    </select>
                                    <button type='button' role="button" onClick={() => navigate(RoutesConstants.ManageGroups)} className="btn btn-primary" >
                                        <i className='fa fa-users'></i> <FormattedMessage id="manage_Groups" />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            
                <div className='container'>
                    {
                    allTrainerlist.length == 0 ? 
                        <div className="d-flex flex-column justify-content-center align-items-center">
                            <svg clip-rule="evenodd" fill-rule="evenodd" height="120" stroke-linejoin="round" stroke-miterlimit="2" viewBox="0 0 64 64" width="120" xmlns="http://www.w3.org/2000/svg"><g id="Exp-2.-F"><path d="m14.387 32.075v-23.365c0-.266.106-.52.293-.707.188-.188.442-.293.707-.293h22.554l11.446 12.692v15.953s.004 1.215-.097 3.083l-5.631-2.043c-.673-.244-1.426-.11-1.973.353-.87.735-2.187 1.849-3.032 2.563-.51.431-1.2.579-1.841.396-1.944-.556-5.974-1.707-5.974-1.707s3.761 2.686 5.769 4.121c.728.52 1.713.493 2.412-.066.898-.719 2.115-1.692 2.931-2.345.551-.44 1.292-.558 1.952-.311l5.176 1.941c-.397 4.314-1.309 9.971-3.398 13.483-.183.289-.501.464-.843.464-3.827.003-26.548.003-32.899.003-.351 0-.676-.184-.857-.485-.18-.301-.19-.675-.025-.984 3.103-6.738 3.33-18.466 3.33-18.466v-1.311l4.388-1.645c.66-.247 1.401-.129 1.951.311.817.653 2.034 1.626 2.932 2.345.699.559 1.684.586 2.412.066 2.008-1.435 5.769-4.121 5.769-4.121s-4.03 1.151-5.974 1.707c-.641.183-1.332.035-1.841-.396-.845-.714-2.162-1.828-3.032-2.563-.547-.463-1.3-.597-1.973-.353z" fill="#cadcf0" /><path d="m48.579 42.153.501.2c-.397 4.314-1.309 9.976-3.399 13.49-.183.289-.501.464-.843.464-3.827.003-26.548.003-32.899.003-.351 0-.676-.185-.857-.486-.18-.3-.19-.674-.025-.984l.039-.086c12.314.579 30.196-1.578 32.551-2.5 1.75-.685 3.818-5.465 4.932-10.101z" fill="#a4bbdb" /><g fill="#347bfa"><path d="m49.387 20.402c-3.035-1.199-6.25-1.233-9.549-.723-.306.048-.617-.049-.842-.263-.224-.214-.337-.52-.304-.828.362-3.694-.003-7.308-.751-10.878 4.838 3.591 8.659 7.819 11.446 12.692z" /><path d="m6.078 23.778 5 5.87c.358.421.989.471 1.409.113s.471-.989.113-1.409l-5-5.87c-.358-.421-.989-.471-1.41-.113-.42.358-.47.989-.112 1.409z" /><path d="m6.132 32.504 3.549.951c.533.143 1.082-.174 1.225-.707s-.174-1.082-.707-1.225l-3.549-.951c-.534-.143-1.082.174-1.225.707s.174 1.082.707 1.225z" /><path d="m5.661 40.729 6.678-3.856c.478-.276.642-.888.366-1.366s-.888-.642-1.366-.366l-6.678 3.856c-.478.276-.642.888-.366 1.366s.888.642 1.366.366z" /><path d="m57.922 51.214-5-5.87c-.358-.42-.989-.47-1.409-.113-.42.358-.471.99-.113 1.41l5 5.87c.358.42.989.471 1.41.113.42-.358.47-.99.112-1.41z" /><path d="m57.868 42.489-3.549-.951c-.533-.143-1.082.174-1.225.707s.174 1.082.707 1.225l3.549.951c.534.142 1.082-.174 1.225-.708.143-.533-.174-1.081-.707-1.224z" /><path d="m58.339 34.264-6.678 3.855c-.478.276-.642.888-.366 1.366s.888.642 1.366.366l6.678-3.855c.478-.276.642-.888.366-1.366s-.888-.642-1.366-.366z" /><path d="m19.864 16.9 3.536 3.536c.39.39 1.024.39 1.414 0 .39-.391.39-1.024 0-1.415l-3.536-3.535c-.39-.39-1.024-.39-1.414 0s-.39 1.024 0 1.414z" /><path d="m23.4 15.486-3.536 3.535c-.39.391-.39 1.024 0 1.415.39.39 1.024.39 1.414 0l3.536-3.536c.39-.39.39-1.024 0-1.414s-1.024-.39-1.414 0z" /><path d="m30.864 16.9 3.536 3.536c.39.39 1.024.39 1.414 0 .39-.391.39-1.024 0-1.415l-3.536-3.535c-.39-.39-1.024-.39-1.414 0s-.39 1.024 0 1.414z" /><path d="m34.4 15.486-3.536 3.535c-.39.391-.39 1.024 0 1.415.39.39 1.024.39 1.414 0l3.536-3.536c.39-.39.39-1.024 0-1.414s-1.024-.39-1.414 0z" /><path d="m22.438 26.409 1.403-1.051s1.397 1.05 1.397 1.05c.356.267.845.267 1.201 0l1.4-1.05s1.4 1.05 1.4 1.05c.355.267.844.267 1.2 0l1.4-1.05s1.4 1.05 1.4 1.05c.441.331 1.069.242 1.4-.2.331-.441.241-1.068-.2-1.4l-1.999-1.5c-.356-.266-.845-.266-1.2 0l-1.401 1.05s-1.4-1.05-1.4-1.05c-.355-.266-.844-.266-1.2 0l-1.4 1.05s-1.396-1.049-1.396-1.049c-.355-.267-.844-.268-1.2-.001l-2.003 1.5c-.442.331-.532.958-.202 1.4.331.441.958.532 1.4.201z" /></g></g></svg>
                            <p className="noData text-muted text-center h4 mb-0"><FormattedMessage id="no_data" /></p>
                        </div>
                     :                         
                        <>
                            <div className="table-responsive">
                                <table className="table tableDesign">
                                    <thead>
                                        <tr>
                                            <th>
                                                <span>
                                                    <button className="btn btn-info btn-sm" onClick={() => handleSelectAll()}>
                                                        <i className="fa fa-plus"></i> <span><FormattedMessage id="Trainer_Select_all_tests" /></span>
                                                    </button>
                                                </span>
                                            </th>
                                            <th><FormattedMessage id="Trainer_Email" /> </th>
                                            <th><FormattedMessage id="Trainer_Name" />  </th>
                                            <th><FormattedMessage id="sent_date" /> </th>
                                            <th><FormattedMessage id="test_date" /> </th>
                                            <th><FormattedMessage id="Trainer_Group" /> </th>
                                            <th></th>
                                            <th><FormattedMessage id="Trainer_Action" /> </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            allTrainerlist.map((item) => {
                                                return <>
                                                    <tr>
                                                        <td>
                                                            {
                                                                item.TestId ?
                                                                    <>
                                                                        {
                                                                            (selectedTestsForComparison.filter((testId: any) => testId === item.TestId).length == 1) ?
                                                                                <button className='btn btn-sm btn-warning' onClick={() => handleRemoveFromCompariosn(item.TestId)}><i className="fa fa-minus"></i> <FormattedMessage id="Trainer_Remove_From_Comparison" /></button>
                                                                                :
                                                                                <button className='btn btn-sm btn-primary' onClick={() => handleAddToComparison(item.TestId)}><span><i className="fa fa-plus"></i> <FormattedMessage id="Trainer_Add_to_Comparison" /></span></button>
                                                                        }
                                                                    </>
                                                                    :
                                                                    <a href={`${RoutesConstants.TestBase}${item.TestLink}`} target="_blank" className="btn btn-sm btn-outline-secondary">
                                                                        <span><i className="fa fa-link"></i> <FormattedMessage id="Trainer_Take_a_test_now" /></span>
                                                                    </a>
                                                            }
                                                        </td>
                                                        <td>{item.RecipientEmail}</td>
                                                        <td>
                                                            {
                                                                item.UserName == ' ' ? <span>-</span> : item.UserName === '' ? <span>-</span> : <span >{item.UserName}</span>
                                                            }
                                                        </td>
                                                        <td>
                                                            {
                                                                item.CreatedDate == '' ? <span>-</span> : <span className="hide">{item.CreatedDate}</span>
                                                            }
                                                        </td>
                                                        <td>
                                                            {
                                                                item.TestDate == '' ? <span>-</span> : <span className="hide">{item.TestDate}</span>
                                                            }
                                                        </td>
                                                        <td>
                                                            {
                                                                item.GroupName == ' ' ? <span>-</span> : item.GroupName === '' ? <span>-</span> : <span >{item.GroupName}</span>
                                                            }					
                                                        </td>
                                                        <td>
                                                            <span className="badge bg-secondary">{item.TestType}</span>
                                                        </td>
                                                        <td>
                                                            <button onClick={() => handleOpenTrainerModalOpen(item.InvitesId)} className="btn btn-outline-info btn-sm" title={formatMessage('edit')}>
                                                                <svg height="492pt" viewBox="0 0 492.49284 492" width="492pt" xmlns="http://www.w3.org/2000/svg"><path d="m304.140625 82.472656-270.976563 270.996094c-1.363281 1.367188-2.347656 3.09375-2.816406 4.949219l-30.035156 120.554687c-.898438 3.628906.167969 7.488282 2.816406 10.136719 2.003906 2.003906 4.734375 3.113281 7.527344 3.113281.855469 0 1.730469-.105468 2.582031-.320312l120.554688-30.039063c1.878906-.46875 3.585937-1.449219 4.949219-2.8125l271-270.976562zm0 0" /><path d="m476.875 45.523438-30.164062-30.164063c-20.160157-20.160156-55.296876-20.140625-75.433594 0l-36.949219 36.949219 105.597656 105.597656 36.949219-36.949219c10.070312-10.066406 15.617188-23.464843 15.617188-37.714843s-5.546876-27.648438-15.617188-37.71875zm0 0" /></svg>
                                                            </button>
                                                            <button className='btn btn-sm btn-outline-warning mx-2'     onClick={() => handleOpenEmailModalOpen(item.InvitesId)} title={formatMessage('send_mail')}>
                                                                <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                                                                        viewBox="0 0 512 512" >
                                                                    <g id="_02_opened">
                                                                        <path d="M333.1,342.2l177.5-136.6v245.7c0,8-1.9,16-5.3,23.2L333.1,342.2z M208.7,319.2l14-10.8c19.6-15.1,46.9-15.1,66.5,0
                                                                                l14,10.8l189.2-145.5L289.3,17.4c-19.6-15.1-46.9-15.1-66.5,0L19.5,173.7L208.7,319.2z M1.3,205.6v245.7c0,8,1.9,16,5.3,23.2
                                                                                l172.2-132.4L1.3,205.6z M267.1,337.3c-6.5-5-15.6-5-22.2,0L32.7,500.4c7.2,3.5,15.2,5.4,23.2,5.5h400.2c8.1-0.1,16-1.9,23.3-5.5
                                                                                L267.1,337.3z"/>
                                                                    </g>
                                                                </svg>
                                                            </button>
                                                            <button className='btn btn-sm btn-outline-danger' onClick={(e) => handleDeleteClick(item.InvitesId, item.RecipientEmail, e)} title={formatMessage('delete')} disabled={item.TestId !== 0 || item.TestDate !== ""}>
                                                            <svg version="1.1" id="Layer_1" viewBox="0 0 512 512" >
                                                                        <g>
                                                                            <g>
                                                                                <path d="M62.205,150l26.569,320.735C90.678,493.865,110.38,512,133.598,512h244.805c23.218,0,42.92-18.135,44.824-41.265
                        L449.795,150H62.205z M180.986,452c-7.852,0-14.458-6.108-14.956-14.063l-15-242c-0.513-8.276,5.771-15.395,14.033-15.908
                        c8.569-0.601,15.381,5.757,15.908,14.033l15,242C196.502,444.632,189.721,452,180.986,452z M271,437c0,8.291-6.709,15-15,15
                        c-8.291,0-15-6.709-15-15V195c0-8.291,6.709-15,15-15s15,6.709,15,15V437z M360.97,195.938l-15,242
                        c-0.493,7.874-7.056,14.436-15.908,14.033c-8.262-0.513-14.546-7.632-14.033-15.908l15-242
                        c0.513-8.276,7.764-14.297,15.908-14.033C355.199,180.543,361.483,187.662,360.97,195.938z"/>
                                                                            </g>
                                                                        </g>
                                                                        <g>
                                                                            <g>
                                                                                <path d="M451,60h-90V45c0-24.814-20.186-45-45-45H196c-24.814,0-45,20.186-45,45v15H61c-16.569,0-30,13.431-30,30
                        c0,16.567,13.431,30,30,30c137.966,0,252.039,0,390,0c16.569,0,30-13.433,30-30C481,73.431,467.569,60,451,60z M331,60H181V45
                        c0-8.276,6.724-15,15-15h120c8.276,0,15,6.724,15,15V60z"/>
                                                                            </g>
                                                                        </g>
                                                                    </svg>
                                                            </button>
                                                            {/* disabled={item.TestId == 0 && item.TestDate == ""}  */}
                                                            
                                                        </td>
                                                    </tr>
                                                </>
                                            })
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </>
                    }
                            <ul className={` mt-4 ${allTrainerlist.length == 0 ? 'd-none' : 'd-flex flex-column flex-md-row justify-content-between'}`}>
                                <li className="page-count-no mb-2">
                                <FormattedMessage id="showing_result_for" />
                                <select
                                    data-testid="pageSelect"
                                    className="pageLimit ms-2"
                                    onChange={onPageLimitChanged}
                                    value={trainerPaginationState.PagingDetails.PageSize}
                                >
                                    {pageLimitOptions.map((op: any) => (
                                    <option key={op} value={op}>
                                        {op}
                                    </option>
                                    ))}
                                </select>
                                </li>
                                <li className="page-number">
                                <Pagination
                                    isRefreshPage={trainerPaginationState.PagingDetails.isRefreshPage}
                                    totalPages={trainerPaginationState.PagingDetails.TotalPages}
                                    pageLimit={trainerPaginationState.PagingDetails.PageSize}
                                    onPageChanged={onPageChanged}
                                    disablePagination={disablePagination}
                                    />
                                </li>
                            </ul> 
                        
                </div>
                <TestCompare selectedTestsForComparison={selectedTestsForComparison} removeAll={handleRemoveAllTests}/>
            </div>
        </>
    )
}

export default RepeatForwardMailInfoPopupHOC(DeletePopupHOC(OpenTrainerPopupHOC(SendInvitiesEmailPopupHOC(observer(TrainerDashboard)))));
